// extracted by mini-css-extract-plugin
module.exports = {"bookmarkListLink":"bookmarkListLink"};